import CameraVideoIcon from 'src/components/svg/chat/CameraVideoIcon';
import MicroIcon from 'src/components/svg/chat/MicroIcon';
import SendStatusIcon from 'src/components/svg/chat/SendStatusIcon';
import RecordedIcon from 'src/components/svg/chat/RecordedIcon';
import StopRecordIcon from 'src/components/svg/chat/StopRecordIcon';
import LockIcon from 'src/components/svg/chat/LockIcon';
import AcceptCallIcon from 'src/components/svg/chat/AcceptCallIcon';
import StopCallIcon from 'src/components/svg/chat/StopCallIcon';
import VolumeIcon from 'src/components/svg/chat/VolumeIcon';
import ModalCallIcon from 'src/components/svg/chat/ModalCallIcon';
import ModalChatIcon from 'src/components/svg/chat/ModalChatIcon';
import ModalVideoIcon from 'src/components/svg/chat/ModalVideoIcon';

const index = {
  'camera-video-icon': CameraVideoIcon,
  'micro-icon': MicroIcon,
  'send-status-icon': SendStatusIcon,
  'recorded-icon': RecordedIcon,
  'stop-record-icon': StopRecordIcon,
  'lock-icon': LockIcon,
  'accept-call-icon': AcceptCallIcon,
  'stop-call-icon': StopCallIcon,
  'volume-icon': VolumeIcon,
  'modal-call-icon': ModalCallIcon,
  'modal-chat-icon': ModalChatIcon,
  'modal-video-icon': ModalVideoIcon,
};

export default index;
